<template>
  <v-dialog
    :value="pricingModelDialogDelete"
    width="600"
    @input="inputDeletePricingDialog"
  >
    <v-card class="rounded-lg pa-2">
      <v-card-title class="justify-center">
        <span class="title">{{ $t('pricing_model.delete.title') }}</span>
      </v-card-title>
      <v-divider />
      <v-card-text class="d-flex flex-column justify-center align-center mt-6">
        <span class="body-2 text-center">
          {{ $t('pricing_model.delete.description') }}
        </span>
        <span class="subtitle-2 mt-2" style="color: #2661ff">
          {{ pricingModel.name }}
        </span>
        <span class="caption red--text text-center mt-6">
          {{ $t('pricing_model.delete.footer') }}
        </span>
      </v-card-text>
      <v-card-actions>
        <v-row>
          <v-col cols="12" class="d-flex justify-end">
            <v-btn
              outlined
              class="rounded-lg mx-2"
              @click="closeDeletePricingModelDialog"
            >
              <span class="black--text">
                {{ $t('general.cancel') }}
              </span>
            </v-btn>
            <v-btn
              color="#2661FF"
              class="rounded-lg mx-2"
              @click="deletePricingModel"
            >
              <span class="white--text">
                {{ $t('actions.remove') }}
              </span>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  name: 'DeletePricingDialog',
  data() {
    return {}
  },
  computed: {
    ...mapState({
      pricingModel: ({ pricingModels: { pricingModel } }) => pricingModel,
      pricingModelDialogDelete: ({
        pricingModels: { pricingModelDialogDelete }
      }) => pricingModelDialogDelete
    })
  },
  methods: {
    ...mapActions({
      deletePricingModelAction: 'pricingModels/deletePricingModel'
    }),
    ...mapMutations({
      setPricingModel: 'pricingModels/setPricingModel',
      setReloadRequired: 'pricingModels/setReloadRequired',
      setPricingModelDialogDelete: 'pricingModels/setPricingModelDialogDelete'
    }),
    inputDeletePricingDialog(arg) {
      if (!arg) this.closeDeletePricingModelDialog()
    },
    closeDeletePricingModelDialog() {
      this.setPricingModel({})
      this.setPricingModelDialogDelete(false)
    },
    async deletePricingModel() {
      const { pricingModel } = this
      try {
        this.isLoading = true

        await this.deletePricingModelAction({
          pricing_model_id: pricingModel.id
        })

        this.setReloadRequired(true)
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
        this.closeDeletePricingModelDialog()
      }
    }
  }
}
</script>
